const enterpriseIds = {
  aditya_c_soni: "Aditya.c.soni",
  nikhila_pala: "Nikhila.pala",
  ashwin_deshpande: "Ashwin.deshpande",
  uma_rani_battu: "uma.rani.battu",
  arpita_singh:"arpita.m.singh",
  ankur_mishra:"ankur.e.mishra",
  reshmi_haridas:"reshmi.haridas.m",
  jeevadharani_ramanan:"jeevadharani.ramanan",
  bharani_ganga_kolla: "bharani.ganga.kolla",
  abhishek_ig_kumar: "abhishek.ig.kumar",
  ajay_kumar_bassi: "ajay.kumar.bassi",
  a_fo_kumar_singh: "a.fo.kumar.singh",
  ujjawal_kumar_singh: "ujjawal.kumar.singh",
  swetha_kuppuswamy: "swetha.kuppuswamy",
  aayushi_a_mishra: "aayushi.a.mishra",
  anushi_pandey: "anushi.pandey",
  venkata_maram_reddy: "venkata.maram.reddy",
  akash_k_raj: "akash.k.raj",
  sandesh_ramesh_naik: "sandesh.ramesh.naik",
  rupali_d_rupali: "rupali.d.rupali",
  komal_satish_mishra: "komal.satish.mishra",
  s_seshadriprasad: "s.seshadriprasad",
  pamera_shashank: "pamera.shashank",
  swatika_singh: "swatika.singh",
  kotni_sireesha: "kotni.sireesha",
  k_trimbakrao_jogdand: "k.trimbakrao.jogdand",
  nikita_apte: "nikita.apte",
  chandini_vardhanapu: "chandini.vardhanapu"
};

const domain = "accenture.com";

const adityacsoni = `${enterpriseIds.aditya_c_soni}@${domain}`;
const nikhilapala = `${enterpriseIds.nikhila_pala}@${domain}`;
const ashwindeshpande = `${enterpriseIds.ashwin_deshpande}@${domain}`;

const umaranibattu = `${enterpriseIds.uma_rani_battu}@${domain}`;
const arpitasingh = `${enterpriseIds.arpita_singh}@${domain}`;
const ankurmishra = `${enterpriseIds.ankur_mishra}@${domain}`;
const reshmiharidas = `${enterpriseIds.reshmi_haridas}@${domain}`;
const jeevadharani_ramanan = `${enterpriseIds.jeevadharani_ramanan}@${domain}`;
const bharanigangakolla = `${enterpriseIds.bharani_ganga_kolla}@${domain}`;
const abhishekigkumar = `${enterpriseIds.abhishek_ig_kumar}@${domain}`;
const ajaykumarbassi = `${enterpriseIds.ajay_kumar_bassi}@${domain}`;
const afokumarsingh = `${enterpriseIds.a_fo_kumar_singh}@${domain}`;
const ujjawalkumarsingh = `${enterpriseIds.ujjawal_kumar_singh}@${domain}`;
const swethakuppuswamy = `${enterpriseIds.swetha_kuppuswamy}@${domain}`;
const aayushiamishra = `${enterpriseIds.aayushi_a_mishra}@${domain}`;
const anushipandey = `${enterpriseIds.anushi_pandey}@${domain}`;
const venkatamaramreddy = `${enterpriseIds.venkata_maram_reddy}@${domain}`;
const akashkraj = `${enterpriseIds.akash_k_raj}@${domain}`;
const sandeshrameshnaik = `${enterpriseIds.sandesh_ramesh_naik}@${domain}`;
const rupalidrupali = `${enterpriseIds.rupali_d_rupali}@${domain}`;
const komalsatishmishra = `${enterpriseIds.komal_satish_mishra}@${domain}`;
const sseshadriprasad = `${enterpriseIds.s_seshadriprasad}@${domain}`;
const pamerashashank = `${enterpriseIds.pamera_shashank}@${domain}`;
const swatikasingh = `${enterpriseIds.swatika_singh}@${domain}`;
const kotnisireesha = `${enterpriseIds.kotni_sireesha}@${domain}`;
const ktrimbakraojogdand = `${enterpriseIds.k_trimbakrao_jogdand}@${domain}`;
const nikitaapte = `${enterpriseIds.nikita_apte}@${domain}`;
const chandinivardhanapu = `${enterpriseIds.chandini_vardhanapu}@${domain}`;

export default {
  adityacsoni,
  nikhilapala,
  ashwindeshpande,
  umaranibattu,
  arpitasingh,
  ankurmishra,
  reshmiharidas,
  jeevadharani_ramanan,
  bharanigangakolla,
  abhishekigkumar,
  ajaykumarbassi,
  afokumarsingh,
  ujjawalkumarsingh,
  swethakuppuswamy,
  aayushiamishra,
  anushipandey,
  venkatamaramreddy,
  akashkraj,
  sandeshrameshnaik,
  rupalidrupali,
  komalsatishmishra,
  sseshadriprasad,
  pamerashashank,
  swatikasingh,
  kotnisireesha,
  ktrimbakraojogdand,
  nikitaapte,
  chandinivardhanapu
};
